define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 面编辑模式。
     *
     * @exports EnumPolygonEditMode
     * 
     * @see Polygon#editMode
     */
    var EnumPolygonEditMode = {
        /**
         * 展示模式。
         * @type {String}
         * @constant
         */
        SHOW: "SHOW",

        /**
         * 创建模式。
         * @type {String}
         * @constant
         */
        CREATE: "CREATE",

        /**
         * 关键点移动模式。
         * @type {String}
         * @constant
         */
        MOVE: "MOVE",

        /**
         * 关键点添加模式。
         * @type {String}
         * @constant
         */
        ADD: "ADD",

        /**
         * 关键点删除模式。
         * @type {String}
         * @constant
         */
        DELETE: "DELETE"
    }
    freezeObject(EnumPolygonEditMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {String} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumPolygonEditMode) {
            if (EnumPolygonEditMode.hasOwnProperty(key) && EnumPolygonEditMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: "SHOW",
        CREATE: "CREATE",
        MOVE: "MOVE",
        ADD: "ADD",
        DELETE: "DELETE",
        getName: getName
    }
})